/* eslint-disable react/no-children-prop */
import React, { useCallback, useEffect, useState } from 'react'

import { TabNavigation, TabPanel, Tabs } from '@/components'
import { Box, Container } from '@material-ui/core'
import { SettingsPaper } from './styles'

import apiEndPoints from '@/consts/apiEndPoints'
import api from '@/services/api'
import handleErrors from '@/services/handleErrors'

import { AvailableDates } from './available-dates'
import { DailyLimits } from './daily-limits'

// -----------------------------------------------

const SETTINGS_TABS = [
  { value: 0, label: 'Datas Disponíveis' },
  { value: 1, label: 'Limites diários' },
]

// -----------------------------------------------

export default function AdminSettingsPage() {
  const [dailyLimits, setDailyLimits] = useState(null)

  const updateDailyLimits = useCallback(() => {
    api
      .get(apiEndPoints.admin.dailyLimits)
      .then((response) => response.data.daily_limits)
      .then(setDailyLimits)
      .catch(handleErrors)
  }, [])

  useEffect(() => {
    updateDailyLimits()
  }, [updateDailyLimits])

  return (
    <TabNavigation>
      <Box
        display="flex"
        flexDirection="column"
        gridGap="0.5rem"
        paddingTop="2rem"
      >
        <Tabs tabs={SETTINGS_TABS} />

        <TabPanel index={0}>
          <Container maxWidth="sm">
            <SettingsPaper>
              <AvailableDates />
            </SettingsPaper>
          </Container>
        </TabPanel>

        <TabPanel index={1}>
          <Container maxWidth="lg">
            <SettingsPaper>
              <DailyLimits dailyLimits={dailyLimits} />
            </SettingsPaper>
          </Container>
        </TabPanel>
      </Box>
    </TabNavigation>
  )
}
